import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { IconButton } from './reportExportButton.styles'
import { LibraryDetailsHoverTooltip } from '../../../components/tooltip/LibraryDetailsTooltip'
import { PermissionTooltip } from '../../../components/tooltip'
import ControlButton from '../sections/devices/components/ControlButton'
import theme from 'theme'
import { hasPermission, isViewerRole, Permission } from 'lib/utils'
import { ConfigurationSettingsIcon } from '../../../components/svg'
import { User } from '@frontegg/redux-store'

const popperProps = {
  sx: {
    marginTop: `-${theme.spacing.sm}px !important`
  }
}

interface ConfigurationSettingsButtonProps {
  authUser: User | null | undefined
  handleOpenDrawer: () => void
}

const ConfigurationSettingsButton: FC<ConfigurationSettingsButtonProps> = ({ authUser, handleOpenDrawer }) => {
  const isDisabled = isViewerRole(authUser) || !hasPermission(Permission.CPIConfigIntegrationView, authUser)

  if (isDisabled) {
    return (
      <PermissionTooltip
        PopperProps={popperProps}
        title={
          <Box className="tooltip-wrapper-permissions">
            <Typography className="tooltip-text">Insufficient permissions</Typography>
          </Box>
        }
      >
        <IconButton disableTouchRipple>
          <ConfigurationSettingsIcon />
        </IconButton>
      </PermissionTooltip>
    )
  }

  return (
    <LibraryDetailsHoverTooltip title="Configuration Settings" placement="bottom-end">
      <div>
        <ControlButton
          type="settings"
          setAnchorEl={() => {
            //
          }}
          handleClick={handleOpenDrawer}
        />
      </div>
    </LibraryDetailsHoverTooltip>
  )
}

export default ConfigurationSettingsButton
